export interface UpdateDefaultParameterCollectionDefaultValueRequest {
  id: string
  revision: number
}

export function UpdateDefaultParameterCollectionDefaultValueRequestToJSON(
  value: UpdateDefaultParameterCollectionDefaultValueRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    revision: value.revision ? value.revision : undefined
  }
}
